import request from './request';
/**
 * 用户相关接口
 * @author 小圣贤君
 * @time 2020/2/21
 */
export default {
  /**
   * 获取用户信息
   * @param userId
   * @param companyId
   */
  getUserInfo(userId, companyId) {
    return request.get('/user/user/getOrderUser?userId=' + userId + "&companyId=" + companyId);
  }

}



// WEBPACK FOOTER //
// ./src/api/userService.js